import { ReactElement } from "react";
import { FormConfig } from "@evergiving/common/dist/es2015/form";

import { DonationIndexPage } from "@/lib/pages/DonationIndexPage";

export function IndexPage({
  formConfig,
}: {
  formConfig: FormConfig;
}): ReactElement {
  if ("payment" in formConfig) {
    return <DonationIndexPage formConfig={formConfig} />;
  }

  return <div>Non-payment forms not yet implemented</div>;
}
